import * as AppPics from 'assets/images';

function Html() {
  return (
    <div className="mainWraper addcoursesection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li className="active">Course Info</li>
          <li>Course Timeline</li>
          <li className="lock">Course Audience</li>
          <li className="lock">Course Membership</li>
          <li className="lock">Course Analytics</li>
        </ul>
        <div className="tab__content">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="prime-head p-0">Adding Course Info</h2>
                <span>Add the course details here</span>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="w-25 p-3">
                  <label htmlFor="">Couse Name</label>
                  <input type="text" placeholder="Enter" />
                </div>
                <div className="w-25 p-3">
                  <label htmlFor="">Class</label>
                  <select required>
                    <option value="" selected="" disabled="">
                      Choose
                    </option>
                    <option value="1">Test</option>
                    <option value="2">Test</option>
                    <option value="3">Test</option>
                  </select>
                </div>
                <div className="w-25 p-3">
                  <label htmlFor="">Board</label>
                  <select required>
                    <option value="" selected="" disabled="">
                      Choose
                    </option>
                    <option value="1">Test</option>
                    <option value="2">Test</option>
                    <option value="3">Test</option>
                  </select>
                </div>
                <div className="w-25 p-3">
                  <label className="w-100" htmlFor="">
                    Country
                  </label>
                  <div className="d-flex align-items-center">
                    <span className="radioBlock">
                      <input id="test1" name="test" value="2" type="radio" />
                      <label htmlFor="test1">United Kingdom</label>
                    </span>
                    <span className="radioBlock">
                      <input id="test2" name="test" checked="check" value="1" type="radio" />
                      <label htmlFor="test2">India</label>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12  col-sm-12">
                <div className="w-25 p-3">
                  <label htmlFor="">Course Overview</label>
                  <textarea name="" id="" cols="20"></textarea>
                </div>
                <div className="w-25 p-3">
                  <label className="w-100" htmlFor="">
                    Course Image
                  </label>
                  <button className="btn-right-content upload">Upload</button>
                </div>
                <div className="w-25 p-3">
                  <label className="w-100" htmlFor="">
                    Course Promo Video
                  </label>
                  <button className="btn-right-content upload">Upload</button>
                </div>
                <div className="w-25 p-3 tab-nmp">
                  <label className="w-100" htmlFor="">
                    Specification/Syllabus
                  </label>
                  <button className="btn-right-content upload">Upload</button>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="w-25 p-3 ">
                  <label htmlFor="">Course Contents</label>
                  <textarea name="" id="" cols="20"></textarea>
                </div>
                <div className="w-25 p-3">
                  <label htmlFor="">Couse ID</label>
                  <input type="text" placeholder="Enter" />
                </div>
                <div className="w-25 p-3 tab-nmp">
                  <label className="mr-4" htmlFor="">
                    Monthly/ Yearly Course
                  </label>
                  <span className="checkBlock">
                    <input id="test3" name="test" value="2" type="checkbox" />
                    <label htmlFor="test3"></label>
                  </span>
                </div>

                <div className="w-25 p-3 tab-nmp">
                  <label className="mr-4" htmlFor="">
                    Is this a Drip Course ?
                  </label>
                  <span className="checkBlock">
                    <input id="test3" name="test" value="2" type="checkbox" />
                    <label htmlFor="test3"></label>
                  </span>

                  <div className="w-100 d-flex flex-column ">
                    <div className="w-100 mt-4">
                      <label htmlFor="">Drip Start Date</label>
                      <select required>
                        <option value="" selected="" disabled="">
                          Choose
                        </option>
                        <option value="1">Test</option>
                        <option value="2">Test</option>
                        <option value="3">Test</option>
                      </select>
                    </div>
                    <div className="w-100 mt-4">
                      <label htmlFor="">Drip End Date</label>
                      <select required>
                        <option value="" selected="" disabled="">
                          Choose
                        </option>
                        <option value="1">Test</option>
                        <option value="2">Test</option>
                        <option value="3">Test</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-5 btnsubmitmain">
              <div className="col-12 btnTab-foot">
                <button className="btn-right-content save">Save Changes</button>
              </div>
            </div>
            <div className="row my-5 pb-3 btnsubmitmain">
              <div className="col-12 btnTab-foot">
                <button className="btn-right-content next">Add Content</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html;
